<button
  type="button"
  class="copy-button"
  [class.copied]="copied()"
  [title]="buttonLabel()"
  [attr.aria-label]="buttonLabel()"
  (click)="copy($event)">
  <i class="pi" [class.pi-copy]="!copied()" [class.pi-check]="copied()" aria-hidden="true"></i>
</button>
